import {
	getRecordingPermissionsAsync,
	requestRecordingPermissionsAsync,
} from "expo-audio";
import { isWeb } from "./platform";

export const requestRecordingPermission = async () => {
	if (!isWeb) {
		const existing = await getRecordingPermissionsAsync();
		if (existing?.status === "granted") {
			return true;
		}
	}

	const next = await requestRecordingPermissionsAsync();
	return next.status === "granted";
};
